import type { ResourcePermissionsApiResponse } from '../permissions/types';
import { transactionAxios } from './schedulingApis';

export async function fetchResourcePermissions(
  customerId: string
): Promise<ResourcePermissionsApiResponse['data']> {
  const response = await transactionAxios.get<ResourcePermissionsApiResponse>(
    `permissions/${customerId}/resource-permissions`
  );

  if (!response.data?.status) {
    throw new Error('Failed to load resource permissions');
  }

  return response.data.data ?? { resources: [] };
}
